export default __webpack_public_path__ + "static/media/camera.a8425579.svg";